export default "__VITE_ASSET__D4h64EsN__"